<template>
    <v-card v-if="readyToLoadTeam"
            elevation="2"
            class="py-0 mt-5 mb-4 flex-grow-1" 
            :style="orientation == 'vertical' ? 'border-top: 6px solid #00818E' : ''">

        <div v-if="Object.keys(moduleInfo).length && moduleInfo.module_class != 1 && moduleInfo.module_key != 'entity-maintenance-program'">
            <div class="d-flex align-center justify-space-between">
                <div class="sansation_subtitle d-inline flex-grow-1"
                    :class="orientation == 'vertical' ? 'mt-6 mb-3 ml-5' : 'pa-4'">
                    Meet the Team
                </div>
                <div class="pr-4 d-inline">
                    <div v-if="orientation == 'vertical'">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                    color="primary darken-1"
                                    dark
                                    v-bind="attrs"
                                    v-on="on"
                                    @click="emailTheTeam(moduleInfo.srg_team.teamemail)">
                                    mdi-email
                                </v-icon>
                            </template>
                            <span>Email The Team</span>
                        </v-tooltip>
                    </div>
                    <div v-else>
                        <v-btn
                            small
                            outlined
                            elevation=0
                            color="primary lighten-1"
                            class="d-inline"
                            @click="emailTheTeam(moduleInfo.srg_team.teamemail)">
                            Email the Team
                        </v-btn>
                    </div>
                </div>
            </div>

            <div :class="orientation == 'vertical' ? 'ma-0 mx-5 pb-4 avenir_book' : 'ma-0 mx-4 pb-4 avenir_book'">
                <div class="d-block mb-8" v-html="moduleInfo.srg_team.statement"></div>

                <div v-if="orientation == 'vertical'">
                    <div class="d-block ma-0 mb-12 text-center"
                            v-for="expert in moduleInfo.srg_team.experts"
                            :key="expert.name">
                        <img :src="require(`@/${expert.image}`)" style="width: 100px" :alt="`${expert.name}, ${expert.title}`" :id="expert.name"><br>
                        <span class="sansation d-block" v-html="`${expert.name}`"></span>
                        <span class="sansation font-weight-light d-block" v-html="`${expert.title}`"></span>
                    </div>
                </div>

                <div v-else>                    
                    <div class="mb-6 d-flex justify-space-around">                         
                        <div v-for="expert in moduleInfo.srg_team.experts" :key="expert.name"
                            class="text-center"
                            style="width:33%">
                            <img :src="require(`@/${expert.image}`)" style="width: 100px" :alt="`${expert.name}, ${expert.title}`" :id="expert.name"><br>
                            <div class="mt-1 sansation" v-html="`${expert.name}`"></div>
                            <div class="sansation font-weight-light" v-html="`${expert.title}`"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-else>
            
            <div class="sansation_subtitle flex-grow-1"
                :class="orientation == 'vertical' ? 'mt-6 mb-3 mx-5' : 'pa-4'">
                Need Assistance?
            </div>

            <div class="ma-0 px-5 pb-4 avenir_book">
                <div class="d-block mb-8">
                    Our support team is here to answer any questions and help keep your {{ isBuyer ? `interests in focus.` : `project on track.` }}
                </div> 
                
                <div v-if="orientation == 'vertical'">
                    <div class="d-block mb-2">                         
                        <div class="mb-6">
                            <h4 class="my-2 sansation">General Questions</h4>
                            <div v-if="isBuyer">
                                <div class="caption font-weight-light">
                                    <a :href="`mailto:${buyer_email.split('').reverse().join('')}`">{{buyer_email.split('').reverse().join('')}}</a><br>
                                </div>
                            </div>
                            <div v-else>
                                <div class="mt-2">Mikaela Devine</div>
                                <div class="caption font-weight-light">
                                    <a :href="`mailto:${mikaela_email.split('').reverse().join('')}`">{{mikaela_email.split('').reverse().join('')}}</a><br>
                                    {{ mikaela_phone }}
                                </div>
                                <div class="mt-4">Robin Tippie</div>
                                <div class="caption font-weight-light">
                                    <a :href="`mailto:${robin_email.split('').reverse().join('')}`">{{robin_email.split('').reverse().join('')}}</a><br>
                                    {{ robin_phone }}
                                </div>
                            </div>
                        </div>

                        <div class="py-6">
                            <h4 class="my-2 sansation">Technical Support</h4>
                            <div v-if="isBuyer">
                                <div class="caption font-weight-light">
                                    <a :href="`mailto:${support_email.split('').reverse().join('')}`">{{support_email.split('').reverse().join('')}}</a><br>
                                </div>
                            </div>
                            <div v-else>
                                <div class="mt-2">Cliff Weiler</div>
                                <div class="caption font-weight-light">
                                    <a :href="`mailto:${cliff_email.split('').reverse().join('')}`">{{cliff_email.split('').reverse().join('')}}</a><br>
                                    {{ cliff_phone }}
                                </div>
                            </div>
                        </div>

                        <div v-if="!isBuyer" class="py-6">
                            <h4 class="my-2 sansation">Sales</h4>
                            <div class="mt-2">Nicole Sinclair</div>
                            <div class="caption font-weight-light">
                                <a :href="`mailto:${nicole_email.split('').reverse().join('')}`">{{nicole_email.split('').reverse().join('')}}</a><br>
                                {{ nicole_phone }}
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div class="mb-6 d-flex justify-space-between">                         
                        <div class="align-self-start">
                            <h4 class="my-2 sansation project_subtitle">General Questions</h4>
                            <div v-if="isBuyer">
                                <div class="caption font-weight-light">
                                    <a :href="`mailto:${buyer_email.split('').reverse().join('')}`">{{buyer_email.split('').reverse().join('')}}</a><br>
                                </div>
                            </div>
                            <div v-else>
                                <div class="mt-2 aniver_book">Mikaela Devine</div>
                                <div class="caption font-weight-light">
                                        <a :href="`mailto:${mikaela_email.split('').reverse().join('')}`">{{mikaela_email.split('').reverse().join('')}}</a><br>
                                    {{ mikaela_phone }}
                                </div>
                                <div class="mt-4 aniver_book">Robin Tippie</div>
                                <div class="caption font-weight-light">
                                        <a :href="`mailto:${robin_email.split('').reverse().join('')}`">{{robin_email.split('').reverse().join('')}}</a><br>
                                    {{ robin_phone }}
                                </div>
                            </div>
                        </div>

                        <div class="align-self-start">
                            <h4 class="my-2 sansation project_subtitle">Technical Support</h4>
                            <div v-if="isBuyer">
                                <div class="caption font-weight-light">
                                    <a :href="`mailto:${support_email.split('').reverse().join('')}`">{{support_email.split('').reverse().join('')}}</a><br>
                                </div>
                            </div>
                            <div v-else>
                                <div class="mt-2 aniver_book">Cliff Weiler</div>
                                <div class="caption font-weight-light">
                                    <a :href="`mailto:${cliff_email.split('').reverse().join('')}`">{{cliff_email.split('').reverse().join('')}}</a><br>
                                    {{ cliff_phone }}
                                </div>
                            </div>
                        </div>

                        <div v-if="!isBuyer" class="align-self-start">
                            <h4 class="my-2 sansation project_subtitle">Sales</h4>
                            <div class="mt-2 aniver_book">Nicole Sinclair</div>
                            <div class="caption font-weight-light">
                                <a :href="`mailto:${nicole_email.split('').reverse().join('')}`">{{nicole_email.split('').reverse().join('')}}</a><br>
                                {{ nicole_phone }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
                
        </div>
    </v-card>
</template>

<script>
import DashListings from './DashListings.vue';
    export default {
  components: { DashListings },
        name: 'ModuleTeamInfo',

        props: {
            moduleInfo: {},
            orientation: String,
            readyToLoadTeam: Boolean,
            isBuyer: Boolean
        },

        data () {
            return {
                mikaela_email: 'moc.puorgecruosernoisseccus@enived.aleakim',
                mikaela_phone: '(503) 427 9910 ext. 1305',

                robin_email: 'moc.puorgecruosernoisseccus@eippit.nibor',
                robin_phone: '(503) 427 9910 ext. 1308',

                cliff_email: 'moc.puorgecruosernoisseccus@reliew.ffilc',
                cliff_phone: '(503) 427 9910 ext. 1314',

                nicole_email: 'moc.puorgecruosernoisseccus@rialcnis.elocin',
                nicole_phone: '(503) 427 9910 ext. 1302',

                buyer_email: 'moc.puorgecruosernoisseccus@reyub',
                support_email: 'moc.puorgecruosernoisseccus@troppus',

                trigger_copied: false,
            }
        },

        methods: {
            emailTheTeam: function ( email_address ) {
                window.open(`mailto:${email_address}`)   
            },

            handleCopyEmail: function () {
                navigator.clipboard.writeText(document.querySelector('div#copy-email').innerText)
                this.trigger_copied = true;
                setTimeout(() => { this.trigger_copied = false; }, 3000);
            },

            beginCall: function ( number ) {
                window.open(`tel:+1${number}`)
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/ModuleTeamInfo.vue